// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__39FUj","col":"CardReaderDesc_col__1EBH0","label":"CardReaderDesc_label__2oS6x"};